import { Pipe, PipeTransform } from '@angular/core';
import type { StandardDropdownItemInterface } from '@zaoblako/shared/common/interfaces/standard-dropdown-item.interface';

import { isNil } from 'lodash';

@Pipe({
  standalone: true,
  name: 'standardDropdownItem'
})
export class StandardDropdownItemPipe implements PipeTransform {
  public transform(
    value: Record<string, any> | null | undefined,
    transformedItems: Record<string | number, StandardDropdownItemInterface> | null | undefined,
    keyProperty?: string | null
  ): StandardDropdownItemInterface | undefined {
    if (isNil(value) || !transformedItems || !keyProperty) {
      return undefined;
    }

    const key = value[keyProperty] as string | number;
    if (isNil(key)) {
      return undefined;
    }
    return transformedItems[key];
  }
}
